import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcRequirementReviewMethodById,
    setCcRequirementReviewMethodEdit,
    setCcRequirementReviewMethodReloadEdit,
    initCcRequirementReviewMethod,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface ReviewMethodEditProps {
    methodId: number
    editAccess: boolean
}

const Edit = ({
    methodId,
    editAccess,
}: ReviewMethodEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const method = useSelector((state: StoreType) => state.ccRequirementReviewMethod.methodEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccRequirementReviewMethod.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcRequirementReviewMethodReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcRequirementReviewMethodReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (methodId === 0) {
            dispatch(setCcRequirementReviewMethodEdit(initCcRequirementReviewMethod))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcRequirementReviewMethodById(methodId, userData.accountId, project.id).then((res) => {
                dispatch(setCcRequirementReviewMethodEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!method) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {
                        method.id
                            ? (editAccess ? `${lang.editMethod} #${method.id}` : `${lang.viewMethod} #${method.id}`)
                            : lang.addMethod
                    }
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form method={method} editAccess={editAccess} />
                }
                {
                    reloadEdit
                    && <Form method={method} editAccess={editAccess} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
